import { Col, Overlay } from "react-bootstrap";
import { DateRangePicker } from "react-date-range";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
import "./DateRange.scss"
import { useEffect, useRef } from "react";
import { CalendarIconSvg } from "../../assets/svg";
function DateRangeSelector({
  issSelectDateRange,
  handleOnChange,
  selectDate,
  setIsSelectDateRange,
  formatedDateRange,
  clx
}: any) {
  const target = useRef(null)
  const overlayRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
        if (overlayRef.current && !overlayRef.current.contains(event.target as Node)) {
            setIsSelectDateRange(false);
        }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
        document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  
  return (
    <>
      <div className={clx}>
        <label className="select-label">Date Range </label>
        <div className="inputMain -mt-1.5 select-range-span">
          <span className="pb-1">
            {" "}
            <input
              className="inputMain cursor-pointer"
              type=""
              placeholder="Select Date Range"
              value={formatedDateRange}
              readOnly
              style={{ color: "#000" }}
              ref={target}
              onClick={() => setIsSelectDateRange((prev: boolean) => !prev)}
            />
            <label className="cursor-pointer " onClick={() => setIsSelectDateRange((prev: boolean) => !prev)}><CalendarIconSvg height={"22px"} width={"22px"} fill="#AAA"/></label>
          </span>
        </div>
      </div>
      <Overlay ref={overlayRef} target={target.current} show={issSelectDateRange} placement="bottom">
        {({
          placement: _placement,
          arrowProps: _arrowProps,
          show: _show,
          popper: _popper,
          hasDoneInitialMeasure: _hasDoneInitialMeasure,
          ...props
        }) => (
          <div
            {...props}
            style={{
              position: 'absolute',
              padding: '2px 10px',
              color: 'white',
              borderRadius: 3,
              ...props.style,
            }}
          >
            <DateRangePicker
              onChange={handleOnChange}
              moveRangeOnFirstSelection={false}
              staticRanges={[]}
              inputRanges={[]}
              startDatePlaceholder="Enter date range"
              months={3}
              ranges={selectDate}
              showMonthAndYearPickers={false}
              rangeColors={["#d0566e"]}
              direction="horizontal"
              minDate={new Date()}
              showDateDisplay={false}
              preventSnapRefocus={true}
            />
          </div>
        )}
      </Overlay>
    </>
  );
}

export default DateRangeSelector;
